import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IngredientDetailsComponent } from '../ingredient-details/ingredient-details.component';
import { UsfProductCardModeEnum } from '@shared/constants/usf-product-card-mode.enum';
import { ItemTypes } from '@app/lists/shared/list-detail-management/model/list-detail-management-view.model';
import { IngredientCardClickEvent } from '@app/mpp/model/ingredient-card-click-event';
import { IngredientCard } from '@app/mpp/model/ingredient-card-model';
import { BasicListItem } from '@shared/models/dual-pane-model';
import { DualPaneView } from '@shared/constants/dual-pane.enum';

@Component({
  selector: 'app-ingredient-detail-touch-modal',
  templateUrl: './ingredient-detail-touch-modal.component.html',
  styleUrls: ['./ingredient-detail-touch-modal.component.scss'],
})
export class IngredientDetailTouchModalComponent extends IngredientDetailsComponent {
  @Input() cardData: IngredientCard;
  @Output() dismissEvent = new EventEmitter<void>();
  @Output() uomDropdownClickEvent =
    new EventEmitter<IngredientCardClickEvent>();
  @Output() quantityInputBlurEvent =
    new EventEmitter<IngredientCardClickEvent>();
  @Output() noteInputBlurEvent = new EventEmitter<IngredientCardClickEvent>();
  constructor() {
    super();
    this.selectedTab = 'default';
  }

  actions: BasicListItem[] = [
    {
      label: 'i18n.menuProfitPro.ingredientDetails.units',
      value: 'unit-of-measure',
      view: DualPaneView.noView,
      selected: false,
    },
  ];
  currentActionsTitle = 'i18n.common.actions';

  dismiss = () => {
    this.dismissEvent.emit();
  };

  submit = () => {
    if (this.selectedTab === 'unit-of-measure')
      this.saveUnitsOfMeasureCalculation();
    this.dismissEvent.emit();
  };

  onProductTouchClick = ($event: number) => {
    this.productEvent.emit($event);
  };

  ellipsisClickTouch($event: Event) {
    this.ellipsisEvent.emit({
      event: $event,
      isTouch: true,
      product: this.product,
      mode: UsfProductCardModeEnum.menuProfitPro,
      itemType: ItemTypes.product,
      list: undefined,
      pricingDisabled: this.pricingDisabled,
      isSelected: false,
    });
  }

  handleUOMUpdate(event: IngredientCardClickEvent) {
    this.uomDropdownClickEvent.emit(event);
  }

  handleNoteuUpdate(event: IngredientCardClickEvent) {
    this.noteInputBlurEvent.emit(event);
  }

  handleQuantityUpdate(event: IngredientCardClickEvent) {
    this.quantityInputBlurEvent.emit(event);
  }

  updateTab(tab: string) {
    this.selectedTab = tab;
    switch (tab) {
      case 'default':
        this.currentActionsTitle = 'i18n.common.actions';
        break;

      case 'unit-of-measure':
        this.currentActionsTitle = 'i18n.menuProfitPro.ingredientDetails.units';
        break;
    }
  }

  saveUnitsOfMeasureCalculation = () => {
    if (
      !!this.currentCalculations?.baseQuantity &&
      !!this.currentCalculations?.conversionQunatity &&
      !!this.currentCalculations?.baseUnit &&
      !!this.currentCalculations?.conversionUnit
    )
      this.saveChangesEvent.emit(this.product?.summary?.netWeight);
  };
}
